import { connect } from "react-redux";
import * as api from "../../../api";
import ConfigManager from "./config-manager";
import { receiveConfig } from "../../../redux/actions/config";

const mapState = () => {
  return {
  };
};

const mapDispatch = dispatch => {
  return {
    getConfig: () => {
      api.getConfiguration().then(data => {
        dispatch(receiveConfig({ _lastUpdated: Date.now(), ...data }));
      });
    }
  };
};

export default connect(mapState, mapDispatch)(ConfigManager);



// WEBPACK FOOTER //
// ./src/components/common/config-manager/config-manager.connect.js